module.exports = __webpack_public_path__ + "img/delivery_box_report.f0418434.png";